import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Text, useDisclosure, VStack } from "@chakra-ui/react"
import { useRef, useState } from "react"
import { InitializePayoutAccount } from "../../../services/PaymentService";
import { Select } from "../../../components/Select";
import { Country } from "@flowko/countries-cities-list";

interface ConfirmConnectPayoutDialogProps {
    onSave?: (stripe_payout_account: any) => void;
}

export const ConfirmConnectPayoutDialog = ({ onSave }: ConfirmConnectPayoutDialogProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [country, setCountry] = useState<any>()
    const [is_loading, setIsLoading] = useState<boolean>()
    const cancelRef = useRef<any>()

    const save = async () => {
        if (country) {
            setIsLoading(() => true)
            const { stripe_payout_account } = await InitializePayoutAccount(country.value)
            setIsLoading(() => false)
            onClose()
            if (onSave) {
                onSave(stripe_payout_account)
            }
        }

    }

    return (
        <>
            <Button color={'green.400'} onClick={onOpen}>Request Payout</Button>

            <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent bg={'#1F1C2C'}>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            Connect a payout account
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>You currently have not connected a payout account. You will receive payments of your content via a Stripe's secure payment method.</Text>
                            <br />
                            <VStack spacing={'6px'} align={'start'} w={'full'}>
                                <Text color={'gray.300'} fontSize={'14px'}>Select country</Text>
                                <Select value={country} setValue={country => setCountry(country)} withSearch={true} placeholder={'Select country'} options={[...Country.getAllCountries().map(item => ({ label: item.name, value: item.isoCode }))]} />
                            </VStack>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Cancel
                            </Button>
                            <Button isDisabled={!country} isLoading={is_loading} loadingText={`Creating account...`} bg={'green.400'} colorScheme={'green'} onClick={save} ml={3}>
                                Proceed
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
}